import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import injectSheet from 'react-jss';

import NavigationService from '-/services/NavigationService';
import Button from '-/components/general/Button';
import SaveButton from '-/components/general/SaveButton';
import {rem, userSelect} from '-/styles/utils';

const styles = () => ({
    root: {
        margin: `${rem(18)} 0 0`,
        padding: `0 ${rem(30)} ${rem(25)}`
    },
    row: {
        display: 'flex',
        '&:not(:first-of-type)': {
            marginTop: rem(15)
        }
    },
    cell: {
        flex: 1,
        '&:not(:only-child)': {
            '&:first-child': {
                marginRight: rem(5)
            }
        },
        '& a, & label': {
            ...userSelect('none'),
            padding: `${rem(10)} 0`,
            border: '1px solid #d2d2d2',
            margin: '0',
            letterSpacing: rem(1.2),
            lineHeight: rem(22),
            whiteSpace: 'nowrap',
            boxShadow: '0 1px 8px rgba(0, 0, 0, 0.12)',
            '& i': {
                verticalAlign: 'middle'
            }
        },
        '&:last-child': {
            textAlign: 'center',
            '& a, & label': {
                color: 'white',
                boxShadow: '0 5px 4px rgba(0, 0, 0, 0.19)'
            }
        }
    },
    text: {
        ...userSelect('none'),
        padding: `${rem(10)} 0`,
        border: '1px solid #d2d2d2',
        margin: '0',
        letterSpacing: rem(1.2),
        lineHeight: rem(22),
        whiteSpace: 'nowrap',
        boxShadow: '0 1px 8px rgba(0, 0, 0, 0.12)',
        '& i': {
            verticalAlign: 'middle'
        }
    }
});

// renders a step component with prev/next buttons
// at the bottom of the screen.
class Step extends Component {
    static propTypes = {
        showPreviousBtn: PropTypes.bool,
        showNextBtn: PropTypes.bool,
        onPreviousClick: PropTypes.func,
        onNextClick: PropTypes.func,
        onReviewClick: PropTypes.func,
        onSaveAndExitClick: PropTypes.func
    };

    static defaultProps = {
        showPreviousBtn: true,
        showNextBtn: true,
        onPreviousClick: () => {},
        onNextClick: () => {},
        onReviewClick: () => {},
        onSaveAndExitClick: () => {}
    };

    render() {
        const {
            children,
            disableButtons = false,
            showPreviousBtn,
            showNextBtn,
            onPreviousClick,
            onNextClick,
            onReviewClick,
            reachedReview,
            onSaveAndExitClick,
            classes = {}
        } = this.props;

        return (
            <div>
                {children}
                {!disableButtons && (
                    <section className={classes.root}>
                        <div className={classes.row}>
                            {showPreviousBtn ? (
                                <div className={classes.cell}>
                                    <Button
                                        tag="a"
                                        btnStyle="previous"
                                        onClick={onPreviousClick}
                                        title="Previous">
                                        Previous
                                    </Button>
                                </div>
                            ) : null}
                            {showNextBtn ? (
                                <div className={classes.cell}>
                                    <Button
                                        tag="a"
                                        onClick={onNextClick}
                                        title="Next Step">
                                        Next Step <i className="fa fa-long-arrow-right" />
                                    </Button>
                                </div>
                            ) : null}
                        </div>
                        {reachedReview ? (
                            <div className={classes.root}>
                                <div className={classes.cell}>
                                    <Button
                                        tag="a"
                                        onClick={onReviewClick}
                                        title="Return">
                                        Return to Review
                                    </Button>
                                </div>
                            </div>
                        ) : null}
                        <div className={classes.row}>
                            <div className={classes.cell}>
                                <SaveButton underline onClick={onSaveAndExitClick} />
                            </div>
                        </div>
                    </section>
                )}
            </div>
        );
    }
}

const mapStateToProps = () => {
    return {reachedReview : NavigationService.showReviewButton()};
};

export default connect(mapStateToProps)(injectSheet(styles)(Step));
